module.exports = __webpack_public_path__ + "static/media/egg.41b6c819.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/egg.png
// module id = 33
// module chunks = 0